import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { addTrack, addTrackTh } from "../Redux/TrackSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));
function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    {/* <CloseIcon /> */}
                    <img src="/images/Home/close_img.png" alt="icon" className="form_close_img" />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}
BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#7500C0"),
    backgroundColor: "#7500C0",
    "&:hover": {
        backgroundColor: "#7500C0",
        color: "#fff",
    },
}));

function AddMorePopup(props) {
    const [track, setTrack] = useState("");
    const [description, setDescription] = useState("");
    const [th, setTh] = useState("");
    const [isTrackNull, setIsTrackNull] = useState(false);
    const [isDescriptionNull, setIsDescriptionNull] = useState(false);
    const [isThNull, setIsThNull] = useState(false);
    const tracks = useSelector((state) => state?.tracks?.tracks);

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const activeUser = activeAccount.idTokenClaims.enterpriseID;

    const dispatch = useDispatch();

    const handleClose = () => {
        props.setOpenAddMore(false);
        setIsTrackNull(false);
        setIsDescriptionNull(false);
        setIsThNull(false);
        setTrack("");
        setTh("");
    };

    //  function to save the qa's
    const saveHandle = () => {
        if (track == "") {
            setIsTrackNull(true)
        } if (description == "") {
            setIsDescriptionNull(true)
        } if (th == "") {
            setIsThNull(true)
        }
        if (track != "" && description != "" && th != "") {
            props.setOpenAddMore(false);
            dispatch(addTrack(track, description, th, activeUser));
            dispatch(addTrackTh(tracks));
            setIsTrackNull(false)
            setIsDescriptionNull(false)
            setIsThNull(false)
            setTrack("");
            setDescription("");
            setTh("");
        }
    };

    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.openAddMore}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    className="popup"
                    sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        textAlign: "center",
                        paddingBottom: "0px !important",
                    }}
                    onClose={handleClose}
                >
                    Add New Track
                </BootstrapDialogTitle>
                <DialogContent sx={{ paddingTop: "15px", width: "600px" }}>
                    <Stack sx={{ padding: "10px", marginTop: "10px" }} spacing={2}>
                        <Stack spacing={1}>
                            <Typography sx={{ fontSize: "14px" }}>
                                Track <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                                error={isTrackNull ? true : false}
                                required={isTrackNull ? false : true}
                                className="coursecode-textfield"
                                size="small"
                                fullWidth
                                multiline
                                id={isTrackNull ? "outlined-error" : "outlined-required"}
                                variant="outlined"
                                helperText={isTrackNull ? "Please enter the track" : null}
                                onChange={(e) => {
                                    setTrack((e.target.value).trim());
                                    if (track !== "") {
                                        setIsTrackNull(false);
                                    }
                                }}
                                sx={{ width: "100%", fontSize: "14px !important" }}
                            />
                        </Stack>
                        <Stack spacing={1}>
                            <Typography sx={{ fontSize: "14px" }}>
                                Track Description <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                                error={isDescriptionNull ? true : false}
                                required={isDescriptionNull ? false : true}
                                className="coursename-textfield"
                                fullWidth
                                multiline
                                size="small"
                                id={isDescriptionNull ? "outlined-error" : "outlined-required"}
                                variant="outlined"
                                helperText={isDescriptionNull ? "Please enter the track description" : null}
                                onChange={(e) => {
                                    setDescription((e.target.value).trim());
                                    if (th !== "") {
                                        setIsDescriptionNull(false);
                                    }
                                }}
                                sx={{ width: "100%", fontSize: "14px !important" }}
                            />
                        </Stack>
                        <Stack spacing={1}>
                            <Typography sx={{ fontSize: "14px" }}>
                                TH (Enter comma seperated enterprise ID's) <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                                error={isThNull ? true : false}
                                required={isThNull ? false : true}
                                className="coursename-textfield"
                                fullWidth
                                multiline
                                size="small"
                                id={isThNull ? "outlined-error" : "outlined-required"}
                                variant="outlined"
                                helperText={isThNull ? "Please enter the course name" : null}
                                onChange={(e) => {
                                    setTh((e.target.value).trim());
                                    if (th !== "") {
                                        setIsThNull(false);
                                    }
                                }}
                                sx={{ width: "100%", fontSize: "14px !important" }}
                            />
                        </Stack>
                    </Stack>

                </DialogContent>
                <DialogActions
                    sx={{ justifyContent: "center", alignItems: "center", marginBottom: "10px" }}
                >
                    <ColorButton
                        variant="contained"
                        className="cancel-button"
                        size="small"
                        sx={{ background: "white", color: "#7500C0", border: "solid 1px #7500C0" }}
                        autoFocus
                        onClick={handleClose}
                    >
                        Cancel
                    </ColorButton>
                    <ColorButton
                        variant="contained"
                        className="save-button"
                        size="small"
                        sx={{ background: "#7500C0", color: "white" }}
                        autoFocus
                        onClick={saveHandle}
                    >
                        Submit
                    </ColorButton>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

export default AddMorePopup;
